//
// WARNING this file is automatically generated by release-gem
//

export const APP_VERSION = "6.25.0";

export const APP_TIMESTAMP = "1792444037";

